import { useMemo } from 'react';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';

export const useContentBoard = () => useMemo(() => contentBoard, []);
